module.exports = __webpack_public_path__ + "static/media/주금산.c7f37f15.jpg";